let url: string = "wss://webapi.odendo.com/api/Socket/Listener";

export function overrideWebsocketUrl(overriddenUrl: string) {
    url = overriddenUrl;
}

export function getWebsocketUrl() {
    return url;
}
